import ENV from 'tio-employee/config/environment';
import { timeZone } from 'tio-common/utils/date/time-zone';
import { generateRequestId } from 'tio-common/utils/request-id';

/**
 * Asks the API whether it accepts a token, by requesting `/me` with it.
 *
 * @param publicKey the company auth key echoed as `x-auth-key`; a preview grant verifies only under it
 * @returns why the token was not accepted, or null when it was
 */
export async function tokenRejectionReason(token: string, publicKey?: string) {
  if (!token) {
    return 'missing token';
  }

  let response: Response;
  try {
    response = await fetch(`${ENV.apiHost}/me`, {
      headers: {
        'x-api-key': ENV.apiKey,
        ...(publicKey && { 'x-auth-key': publicKey }),
        'tio-auth-token': token,
        Accept: 'application/vnd.api+json',
        'Time-Zone': timeZone(),
        'X-Request-Id': generateRequestId(),
      },
    });
  } catch (e) {
    return (e as Error).message;
  }

  if (response.status >= 500) {
    return 'server error';
  }
  if (response.status >= 400) {
    return 'invalid token';
  }
  return null;
}
